import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _machineUrls, _PacsEditTagsUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, MachineProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const machineApi = {
    fetchMachineApi: createAsyncThunk(
        "machine/add",
        async (props: MachineProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _machineUrls.add(props.deviceName),
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                        body: JSON.stringify(props.savedInformation),
                    }
                );
                if (!response.ok) {
                    throw new Error('Failed to update patient tags');
                }

                if (response.status === 204) {
                    return { status: 204, success: true, message: "Machine saved successfully." };
                }

                const data: ApiResponse<any> = await response.json();
                return { ...data, status: response.status, success: true };

            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    ),
};
